import { TopicGroupTypeCode } from '../../generated/hooks';

/** GraphQL ID of the Arnold system user (`SYSTEM_USER_ID` in the API). */
const SYSTEM_USER_ID = '1';

type PulserTopicGroupLike = {
  typeCode?: TopicGroupTypeCode | string | null;
};

type PulserSurveyLike = {
  user?: { id?: string | null } | null;
  topicGroup?: PulserTopicGroupLike | null;
};

export const isPulserTopicGroup = (topicGroup?: PulserTopicGroupLike | null): boolean =>
  topicGroup?.typeCode === TopicGroupTypeCode.Pulser;

export const isPulserSurvey = (survey: PulserSurveyLike): boolean => isPulserTopicGroup(survey.topicGroup);

export const isImportedPulserSurvey = (survey: PulserSurveyLike): boolean =>
  isPulserSurvey(survey) && String(survey.user?.id) === SYSTEM_USER_ID;
